export default "__VITE_ASSET__DlvAlvc8__"